import { Box } from '@mui/material';
import React from 'react';
import { Container, Row } from 'react-bootstrap';

import { Blog } from '../sections/Blog';
import { Brand } from '../sections/Brand';
import { Testimonial } from '../sections/Testimonial';
import { Team } from '../sections/Team';
import { Link } from 'react-router-dom';
import useDocumentTitle from '../useDocumentTitle';

export const Home = () => {

  useDocumentTitle('Home – IMUII Web');

  return (
    <>

      {/* Main Banner Section */}
      <section className='home_section'>
        <div className='home_banner_bg'>
          <div className='svg-1'>
            <img src="../assets/images/3.svg" alt="" />
          </div>
          <div className='png-1'>
            <img src="../assets/images/1.png" alt="" />
          </div>
          <div className='gallery-img'>
            <img src="../assets/images/gallery.svg" alt="" />
          </div>
          <div className='png-2'>
            <img src="../assets/images/2.png" alt="" />
          </div>
          <div className='dot-img'>
            <img src="../assets/images/dot-img.png" alt="" />
          </div>
          <div className='c-img'>
            <img src="../assets/images/c.svg" alt="" />
          </div>
          <div className='lay-img'>
            <img src="../assets/images/lay-img.png" alt="" />
          </div>
          <div className='imo-5'>
            <img src="../assets/images/imo-5.svg" alt="" />
          </div>
          
          <div className='whi-5'>
            <img src="../assets/images/whi-5.svg" alt="" />
          </div>
          <div className='whi-6'>
            <img src="../assets/images/whi-6.svg" alt="" />
          </div>
          <Container>
            <Row className='justify-content-center'>
              <div className='col-xl-6 col-lg-7 col-md-9'>
                <div className='home_content text-center'>
                  <h1 data-aos="fade-right" data-aos-duration="1500">Excellent IT <span className='service-color'>Services</span> for Your Success</h1>
                  <p data-aos="fade-left" data-aos-duration="1500">At IMUII Technology Pvt Ltd, we make smart solutions with clear purpose. We help startups and big companies build what they need, with focus on customers and real results. Our team works close with clients, from idea to final product. We keep things simple, honest, and strong—so your business can grow fast and lead with technology. </p>
                  <Box data-aos="fade-up" data-aos-duration="1500" sx={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: {
                      xs: "10px",  
                      sm: "15px",  
                      md: "20px", 
                      lg: "20px",  
                      xl: "20px" 
                    },
                    justifyContent: "center"
                  }}>
                    <Link to='/contact'>
                        <button className='get-btn'>Get Started</button>
                    </Link>
                    <Link to='/contact'>
                        <button className='us-btn'>Contact Us</button>
                    </Link>
                  </Box>
                </div>
              </div>
            </Row>
            
            <div className='position-relative men-margin'>
              <div className='home-layout text-center'>
                <svg className='rainbow' viewBox="0 0 800 400" style={{backgroundColor: 'transparent'}}>
                  <circle cx="400" cy="420" r="400" stroke="none" strokeWidth="2" fill="#fbddde" />
                  <circle cx="400" cy="420" r="300" stroke="none" strokeWidth="2"  fill="#f6d0d6" />
                  <circle cx="400" cy="420" r="170" stroke="none" strokeWidth="2" fill="#f6c6cb" />
                </svg>
              
              </div>
              <div className='men-img'>
                <img src="../assets/images/banner-men.png" alt="" />
              </div>

              <div className='grp-img'>
                <img src="../assets/images/grp-img.png" alt="" />
              </div>
              <div className='kai-img'>
                <img src="../assets/images/kai.svg" alt="" />
              </div>
              <div className='act-img'>
                <img src="../assets/images/active-img.png" alt="" />
              </div>

              <div className='whi-1'>
                <img src="../assets/images/whi-1.svg" alt="" />
              </div>
              
              <div className='imo-1'>
                <img src="../assets/images/imo-1.svg" alt="" />
              </div>
              <div className='imo-2'>
                <img src="../assets/images/imo-2.svg" alt="" />
              </div>
              <div className='imo-3'>
                <img src="../assets/images/imo-3.svg" alt="" />
              </div>
              <div className='imo-4'>
                <img src="../assets/images/imo-4.svg" alt="" />
              </div>
              <div className='whi-2'>
                <img src="../assets/images/whi-2.svg" alt="" />
              </div>
              <div className='whi-3'>
                <img src="../assets/images/whi-3.svg" alt="" />
              </div>
              <div className='imo-6'>
                <img src="../assets/images/imo-6.svg" alt="" />
              </div>
              <div className='imo-7'>
                <img src="../assets/images/imo-7.svg" alt="" />
              </div>
              <div className='meow'>
                <img src="../assets/images/meow.svg" alt="" />
              </div>
            </div>
          </Container>
        </div>
      </section>


      {/* About Section */}
      <section className='about_section'>
        <Container>
          <Row className='align-items-center'>
            <Box className='col-lg-5 margin-about'>
                <div data-aos="fade-right" data-aos-duration="2000" className='position-relative mb-lg-0 mb-40'>
                    <div className='about-img text-center'>
                        <img src="../assets/images/about-img.png" alt="" />
                    </div>
                    <div className='arrow-svg'>
                        <img src="../assets/images/arrow.svg" alt="" />
                    </div>
                    <div className='meow-1'>
                        <img src="../assets/images/meow.svg" alt="" />
                    </div>
                    <div className='imo-8'>
                        <img src="../assets/images/imo-8.svg" alt="" />
                    </div>
                    <div className='imo-9'>
                        <img src="../assets/images/imo-9.svg" alt="" />
                    </div>
                    <div className='pink-dotted'>
                        <img src="../assets/images/dot-img.png" alt="" />
                    </div>
                </div>
            </Box>
            <Box className='col-lg-7'>
              <div className='about-area'>
                  <div className='about-content'  data-aos="fade-down" data-aos-easing="linear" data-aos-duration="1500">
                    <h5>OUR ROOTS</h5>
                    <h3>We Are Growing Business Success with Technology </h3>
                    <p>We mix future thinking with simple and strong way of working. We focus on doing the work right, turning ideas into real actions, and always delivering with best quality. </p>
                  </div>
                  
                  <Row data-aos="fade-left" data-aos-duration="2000">
                    <div className='col-md-6 '>
                        <div className='about-border'>

                            <Box sx={{
                                display: "flex",
                                gap: "15px",
                                alignItems: "center",
                                marginBottom: "15px"
                            }}>
                                <div className='about-icon'>
                                <img src="../assets/images/palp.svg" alt="" />
                                </div>
                                <div className='about-text'>
                                <h3>Problem Solving</h3>
                                </div>
                            </Box>
                            <div>
                                <p>We believe in solving real problems, not just talking. With smart ideas and simple steps, we help our clients move fast and reach their goals with full confidence. </p>
                            </div>
                        </div>
                    </div>
                    <div className='col-md-6'>
                      <Box sx={{
                        display: "flex",
                        gap: "15px",
                        alignItems: "center",
                        marginBottom: "15px"
                      }}>
                        <div className='about-icon'>
                          <img src="../assets/images/traget.svg" alt="" />
                        </div>
                        <div className='about-text'>
                          <h3>Mission & Vision</h3>
                        </div>
                      </Box>
                      <div className='our-text'>
                        <p>Our mission is to build smart, useful tech that helps people and businesses grow. Our vision is to be trusted partner for companies around the world, making technology easy and powerful for all. </p>
                      </div>
                    </div>
                  </Row>
                  <Box data-aos="zoom-in" data-aos-duration="1000" sx={{
                    marginTop: "20px"
                  }}>
                    
                    <Link to='/about'>
                        <button className="read-btn">
                            <span className="button-content">Read More </span>
                        </button>
                    </Link>
                  </Box>
              </div>
            </Box>
          </Row>
        </Container>
      </section>

      {/* Counter Up Section */}
      <section className='counter-section'>
        <Container>
          <Row className='justify-content-center'>
            <div className='col-xl-22 col-lg-3 col-md-4 col-6 mb-xl-0 mb-20'>
              <div className='counter_content text-center'>
                <img src="../assets/images/counter-1.svg" alt="" />
                <h2>2K+</h2>
                <p>Web Development</p>
              </div>
            </div>
            <div className='col-xl-22 col-lg-3 col-md-4 col-6 mb-xl-0 mb-20'>
              <div className='counter_content text-center'>
                <img src="../assets/images/counter-2.svg" alt="" />
                <h2>1K+</h2>
                <p>App Development</p>
              </div>
            </div>
            <div className='col-xl-22 col-lg-3 col-md-4 col-6 mb-xl-0 mb-20'>
              <div className='counter_content text-center'>
                <img src="../assets/images/counter-3.svg" alt="" />
                <h2>25+</h2>
                <p>Our Products</p>
              </div>
            </div>
            <div className='col-xl-22 col-lg-3 col-md-4 col-6 mb-xl-0 mb-20'>
              <div className='counter_content text-center'>
                <img src="../assets/images/counter-4.svg" alt="" />
                <h2>30K+</h2>
                <p>Happy Clients</p>
              </div>
            </div>
            <div className='col-xl-22 col-lg-3 col-md-4 col-6 mb-xl-0 mb-20'>
              <div className='counter_content text-center'>
                <img src="../assets/images/counter-5.svg" alt="" />
                <h2>40K+</h2>
                <p>Project Delivered</p>
              </div>
            </div>
          </Row>
        </Container>
      </section>

      {/* Service Section */}
      <section className='service_section'>
        <div className='sicon-11'>
          <img src="../assets/images/sicon-11.svg" alt="" />
        </div>
        <div className='sdots'>
          <img src="../assets/images/dot-img.png" alt="" />
        </div>
        <Container>
          <h5 className='service-text' data-aos="fade-right" data-aos-duration="2000">Our Services</h5>

          <div className='service-flex ser-padding'>
            <div data-aos="fade-right" data-aos-duration="2000">
              <h4>Unlock Your Business Potential – Elevate to the Next Level </h4>
            </div>


          </div>
          <Row>
            <div className='col-xl-9 col-lg-8' data-aos="fade-right" data-aos-duration="2000">
              <Row>
                <div className='col-md-6 mb-25'>
                    <Link to='/eCommerce-development'>
                        <div className='service-card-1 position-relative'>
                            <div className='service-content'>
                            <h3>E-commerce Development </h3>
                            <p>We build smart, secure, and scalable E-commerce solutions that help your business sell better online. From user-friendly storefronts to powerful backend systems, we ensure smooth shopping experiences for your customers. Whether you're a startup or an established brand, we tailor platforms that grow with your business. Our team focuses on results—driving traffic, increasing conversions, and making online sales simple, fast, and reliable for all kinds of customers and industries. </p>
                            </div>
                            <div className='sicon-10'>
                            <img src="../assets/images/sicon-10.svg" alt="" />
                            </div>
                            <div className='sicon-9'>
                            <img src="../assets/images/sicon-9.svg" alt="" />
                            </div>
                        </div>
                    </Link>
                  
                </div>
                <div className='col-md-6 mb-25'>
                    <Link to='/cybersecurity'>
                        <div className='service-card-2 position-relative'>
                            <div className='service-content'>
                            <h3>Cybersecurity </h3>
                            <p>At IMUII, cybersecurity isn’t just a service—it’s a commitment. We design and implement advanced digital defence systems that protect your data, infrastructure, and people. Whether you’re a growing startup or a global enterprise, our cybersecurity solutions scale with your needs to keep threats out and operations secure. </p>
                            </div>
                            <div className='sicon-6'>
                            <img src="../assets/images/sicon-6.svg" alt="" />
                            </div>
                            <div className='sicon-7'>
                            <img src="../assets/images/sicon-7.svg" alt="" />
                            </div>
                            <div className='sicon-8'>
                            <img src="../assets/images/sicon-8.svg" alt="" />
                            </div>
                        </div>
                    </Link>
                </div>
                <div className='col-md-12 mb-25'>
                    <Link to='/web-development'>
                        <div className='service-card-3 position-relative'>
                            <div className='service-content'>
                            <h3>Web Development </h3>
                            <p>We create fast, modern websites that bring your ideas to life and help your business grow online. Using the latest tools and clean code, we build sites that load fast, work on all devices, and are easy to manage. From simple landing pages to full-featured platforms, we develop solutions that match your goals. Our web development focuses on performance, security, and a smooth user experience across all browsers and screens. </p>
                            </div>
                            <div className='sicon-3'>
                            <img src="../assets/images/sicon-3.svg" alt="" />
                            </div>
                            <div className='sicon-4'>
                            <img src="../assets/images/sicon-4.svg" alt="" />
                            </div>
                            <div className='sicon-5'>
                            <img src="../assets/images/sicon-5.svg" alt="" />
                            </div>
                        </div>
                    </Link>
                </div>
              </Row>
            </div>
            <div className='col-xl-3 col-lg-4 mb-25 our-flex' data-aos="fade-left" data-aos-duration="2000">
                <Link to='/saas-development'>
                    <div className='service-card-4 position-relative'>
                        <div className='service-content'>
                        <h3 className='px-lg-3'>SAAS Development </h3>
                        <p>At IMUII, we craft scalable, secure, and cloud-native SaaS (Software as a Service) solutions that adapt to your business needs. From startups to enterprises, our end-to-end SaaS development process ensures fast deployment, seamless user experience, and continuous innovation. </p>
                        </div>
                        
                        <div className='sicon-1'>
                        <img src="../assets/images/sicon-1.svg" alt="" />
                        </div>
                        <div className='sicon-2'>
                        <img src="../assets/images/sicon-2.svg" alt="" />
                        </div>
                    </div>
                </Link>
            </div>
          </Row>
        </Container>
      </section>

      {/* Why Choose Section */}
      <section className='choose_section'>
        <Container>
          <Row>
            <div className='col-lg-6'>
              <div className='choose-padding'>
                <div data-aos="fade-right" data-aos-duration="2500" className='choose-content'>
                  <h5 className='line-1-dot'>Why Choose Us</h5>
                  <h4 className='line-2-dot'>We Provide Truly Prominent IT Solutions </h4>
                  <p>In today’s fast-moving digital world, handling information the right way is key to staying ahead. Our Information Management System (IMS) helps your business organize, protect, and use data more efficiently. </p>
                </div>
                <Row data-aos="fade-right" data-aos-duration="2000">
                  <div className='col-md-6 mb-16'>
                    <Link to='/eCommerce-development'>
                      <div className='choose-card'>
                        <Box className='gap-15' sx={{
                          display: "flex",
                          alignItems: "center"
                        }}>
                          <div className='whyicon'>
                            <img src="../assets/images/whyicon-2.svg" alt="" />
                          </div>
                          <h4>E-commerce Development </h4>
                        </Box>
                      </div>
                    </Link>
                  </div>
                  <div className='col-md-6 mb-16'>
                    <Link to='/cybersecurity'>
                      <div className='choose-card'>
                        <Box className='gap-15' sx={{
                          display: "flex",
                          alignItems: "center"
                        }}>
                          <div className='whyicon'>
                            <img src="../assets/images/whyicon-3.svg" alt="" />
                          </div>
                          <h4>Cybersecurity </h4>
                        </Box>
                      </div>
                    </Link>
                  </div>
                  <div className='col-md-6 mb-16'>
                    <Link to='/saas-development'>
                      <div className='choose-card'>
                        <Box className='gap-15' sx={{
                          display: "flex",
                          alignItems: "center"
                        }}>
                          <div className='whyicon'>
                            <img src="../assets/images/whyicon-1.svg" alt="" />
                          </div>
                          <h4>SAAS Development </h4>
                        </Box>
                      </div>
                    </Link>
                  </div>
                  <div className='col-md-6 mb-16'>
                    <Link to='/web-development'>
                      <div className='choose-card'>
                        <Box className='gap-15' sx={{
                          display: "flex",
                          alignItems: "center"
                        }}>
                          <div className='whyicon'>
                            <img src="../assets/images/whyicon-4.svg" alt="" />
                          </div>
                          <h4>Web Development </h4>
                        </Box>
                      </div>
                    </Link>
                  </div>
                </Row>
              </div>
            </div>
            <div className='col-lg-6'>
              <div className='choose-flex' data-aos="fade-left" data-aos-duration="2000">
                <div className='choose-position text-center'>
                  <img className='choose-img' src="../assets/images/choose-img.png" alt="" />

                  <div className='shap-1'>
                    <img src="../assets/images/shap-1.svg" alt="" />
                  </div>
                  <div className='shap-2'>
                    <img src="../assets/images/shap-2.svg" alt="" />
                  </div>
                  <div className='shap-3'>
                    <img src="../assets/images/shap-3.svg" alt="" />
                  </div>

                  {/* Icons */}
                  <div className='why-1'>
                    <img src="../assets/images/why-1.svg" alt="" />
                  </div>
                  <div className='why-2'>
                    <img src="../assets/images/why-2.svg" alt="" />
                  </div>
                  <div className='why-3'>
                    <img src="../assets/images/why-3.svg" alt="" />
                  </div>
                  <div className='why-4'>
                    <img src="../assets/images/why-4.png" alt="" />
                  </div>
                  <div className='why-5'>
                    <img src="../assets/images/why-5.png" alt="" />
                  </div>
                  <div className='pink-dotted-1'>
                        <img src="../assets/images/dot-img.png" alt="" />
                    </div>
                </div>
              </div>
            </div>
          </Row>
        </Container>
      </section>

      {/* Our People Section */}
      <Team />

      {/*Visit Section */}
      <section className='visit_section'>
        <Row className='align-items-center'>
          <div className='col-md-8 d-md-block d-none'>
            <div className='visit-img'>
              <img src="../assets/images/visit-img.png" alt="" />
            </div>
          </div>
          <div className='col-md-4'>
            <div className='visit-area' data-aos="fade-left" data-aos-duration="2000">
              <h3>Visit IMUII</h3>
              <h4>& grow your passion with us!</h4>

              <Link to='/career'>
                <button className='visit-btn'>Career With Us</button>
              </Link>
            </div>
          </div>
        </Row>
      </section>

      {/* Blog Section */}
      <Blog />

      {/* Brand Section */}
      <Brand />

      {/* Testimonial Section */}
      <Testimonial />
      
    </>
  )
}
